import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export function exportToExcel(data: Record<string, any>[], fileName: string, sheetName = 'Sheet1') {
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}

export function exportToPDF(
  columns: { header: string; key: string }[],
  data: Record<string, any>[],
  fileName: string,
  title?: string
) {
  const doc = new jsPDF();

  if (title) {
    doc.setFontSize(16);
    doc.text(title, 14, 20);
  }

  const headers = columns.map(c => c.header);
  const rows = data.map(row => columns.map(c => String(row[c.key] ?? '')));

  autoTable(doc, {
    head: [headers],
    body: rows,
    startY: title ? 30 : 14,
    styles: { fontSize: 9 },
    headStyles: { fillColor: [34, 51, 84] },
  });

  doc.save(`${fileName}.pdf`);
}
